// 获取推送服务器信息
export const GET_PUSH_SERVICE_INFO = 'GET_PUSH_SERVICE_INFO';

// 开始推送
export const START_PUSH = 'START_PUSH';

// 关闭推送
export const END_PUSH = 'END_PUSH';

// 推送彩种销售状态
export const LIVE_SALE_INFO = 'LIVE_SALE_INFO';

// 同步用户余额
export const LIVE_USER_BALANCE = 'LIVE_USER_BALANCE';

// 同步最新奖期
export const LIVE_ISSUE_DATA = 'LIVE_ISSUE_DATA'

// 同步奖期，左侧彩种栏
export const LIVE_ISSUE_CODE_4_MENU = 'LIVE_ISSUE_CODE_4_MENU'

// 同步聊天未读消息数
export const LIVE_UNREAD_CHAT_COUNT = 'LIVE_UNREAD_CHAT_COUNT'

// 同步站内信未读数
export const LIVE_UNREAD_NOTICE_COUNT = 'LIVE_UNREAD_NOTICE_COUNT';